<template>
    <div class="setting-content--section">
        <InvoiceSettingsForm ref="invoice-settings-form" @updated="showDismissibleCountdown=2" />
        <b-alert class="float-alert-top" :show="showDismissibleCountdown" variant="success" dismissible @dismissed="showDismissibleCountdown=0" v-translate>
            Settings successfully updated!
        </b-alert>
    </div>
</template>

<script>
import VueDropzone from "@/components/VueDropzone"
import GekkoButton from "@/components/GekkoButton"

import InvoiceDesign from "@/views/settings/InvoiceDesign"
import InvoiceSettingsForm from "@/components/invoices/InvoiceSettingsForm"

// mixins
import settingsPageSetup from "@/mixins/settingsPageSetup"

export default {
    name: "InvoiceSettings",
    components: {
        VueDropzone,
        GekkoButton,
        InvoiceDesign,
        InvoiceSettingsForm
    },
    mixins: [settingsPageSetup],
    data () {
        return {
            showDismissibleCountdown: 0,
            pageSettings: {
                title: this.$gettext("Invoice details"),
                showCompanyPicker: true
            }
        }
    },
    computed: {
    },
    beforeRouteLeave (to, from , next) {
        if (this.$refs['invoice-settings-form'].formChanged) {
            const ConfirmModalConstructor = this.$options.components['confirm-modal']
            const confirmModalInstance = new ConfirmModalConstructor({ propsData: {
                title: this.$gettext('Leaving this page'),
                message: this.$gettext('You made changes that have not yet been saved. Are you sure you want to continue and discard those changes?'),
                options: {
                    variant: 'primary',
                    confirmText: this.$gettext('Ok')
                }
            }})
            confirmModalInstance.$mount()
            document.body.appendChild(confirmModalInstance.$el)
            confirmModalInstance.$on('confirmed', () => {
                if (confirmModalInstance && confirmModalInstance.$el.parentNode) {
                    confirmModalInstance.$el.parentNode.removeChild(confirmModalInstance.$el)
                }
                next()
            })
            confirmModalInstance.$on('cancel', () => {
                if (confirmModalInstance && confirmModalInstance.$el.parentNode) {
                    confirmModalInstance.$el.parentNode.removeChild(confirmModalInstance.$el)
                }
            })
        } else {
            next()
        }
    },
    created () {
    },
    methods: {

    }
};
</script>
<style lang="scss">
.checkbox-bg-color .custom-control-input:checked ~ .custom-control-label::before{
    border-color: #0575ff;
    background-color: #0575ff;
}
.width50 {
    max-width: 41.6666666667% !important;
    width: 41.6666666667%  !important;
}
.float-alert-top{
    position: fixed !important;
    top: 50px;
    right: 15%;
    z-index: 1000;
}

.settings-main-tabs {
    .nav-tabs .nav-link {
        padding: 0.75rem 1rem;
    }
}
</style>
